// extracted by mini-css-extract-plugin
export var button = "_il-0";
export var donut = "_il-1";
export var donutFill = "_il-3";
export var donutTrack = "_il-2";